import { useEffect } from 'react';

export const useApplyCallbackOnScroll = (
  disabled: boolean,
  callback: () => void,
): void => {
  useEffect(() => {
    if (disabled) {
      return;
    }

    document.body.addEventListener('scroll', callback, true);
    return () => document.body.removeEventListener('scroll', callback, true);
  }, [disabled]);
};
